import React, { useState, useEffect } from 'react'
import StatsComponent from '../BuisnessDashboard/common/StatsComponent'
import InfoIcon from '@mui/icons-material/Info';
import moment from 'moment';
import Loader from '../../../presentationals/Loader/Loader.component'
import { InitalDateFn } from '../../../../utils/commonUtility';
import { getCountSatusWise } from '../../Admin/AdminActionCreator.component';
import { projectionDataDaywise } from '../actioncreatormarketing';
import { ChevronLeft } from 'lucide-react';
import DateFilterSelect from '../../../CustomDatePicker/DateFilterSelectold';

const customMarginTop = window.innerWidth > 1800 ? "60px" : "30px"
export default function Projection({ handleBack, handleFilter, commonFilter }) {
    const dateType = "disbursedate";
    const noOfMonth = "3";
    const [openAccordian, setOpenAccordian] = useState(null)
    const [loader, setLoader] = useState(false)
    const [tableData, setTableData] = useState([])
    // const [dateFilterPopup, setDateFilterPopup] = useState({ show: false, from: moment().subtract(6, 'days').format("YYYY-MM-DD"), to: moment(new Date).format("YYYY-MM-DD") })
    const [dateFilterPopup, setDateFilterPopup] = useState({ show: false,from: commonFilter?.fromDate, to: commonFilter?.toDate  })

    const [statsOption, setStatsOption] = useState({})
    const [isFilterCleared, setIsFilterCleared] = useState(false);


    const handleDateFilterPopup = (type, val) => {
        const formatted = moment(val).format("YYYY-MM-DD");

        setDateFilterPopup((prev) => {
            if (prev[type] === formatted) return prev; // prevent useless update

            return {
                ...prev,
                [type]: formatted
            };
        });

        if (type === "from") {
            if (commonFilter.fromDate !== formatted) {
                handleFilter("fromDate", formatted);
            }
        } else {
            if (commonFilter.toDate !== formatted) {
                handleFilter("toDate", formatted);
            }
        }
    }
    useEffect(() => {
        if (
            commonFilter?.fromDate !== dateFilterPopup.from ||
            commonFilter?.toDate !== dateFilterPopup.to
        ) {
            setDateFilterPopup((prev) => ({
                ...prev,
                from: commonFilter.fromDate,
                to: commonFilter.toDate
            }));
        }
        handleStats(commonFilter.fromDate, commonFilter.toDate)
        handleAccordData(commonFilter.fromDate, commonFilter.toDate)
    }, [commonFilter]);


    const handleApplyDteFilter = () => {
        handleDateFilterPopup("show", false)
        handleStats(dateFilterPopup?.from, dateFilterPopup?.to)
        handleAccordData(dateFilterPopup?.from, dateFilterPopup?.to)
    }
    const handleReset = () => {
        const today = moment(new Date).format("YYYY-MM-DD");

        setDateFilterPopup({ show: false, from: today, to: today })
        setIsFilterCleared(true)

        handleStats(today, today)
        handleAccordData(today, today)
        setTimeout(() => setIsFilterCleared(false), 0);

    }

    const handleAccordion = (val) => {
        setOpenAccordian((prev) => prev == val ? null : val)
    }

    // useEffect(() => {
    //     handleStats(dateFilterPopup?.from, dateFilterPopup?.to)
    //     handleAccordData(dateFilterPopup?.from, dateFilterPopup?.to)
    // }, [dateFilterPopup?.from, dateFilterPopup?.to])

    const handleStats = (sDate, eDate) => {
        const start = moment(sDate).format("DD-MM-YYYY")
        const end = moment(eDate).format("DD-MM-YYYY")
        // setLoader(true)
        getCountSatusWise(start, end, dateType, callback => {
            // setLoader(false)
            setStatsOption({
                "Total Application Count": callback?.totalApplications ?? 0,
                "Repeat Leads Count": callback?.repeatLeads ?? 0,
                "Fresh Leads Count": callback?.freshLeads ?? 0,
                "Fresh Disbursement Amount": Number(parseFloat(callback?.freshDisbursement).toFixed(2)).toLocaleString('en-IN') ?? 0,
                "Repeat Disbursement Amount": Number(parseFloat(callback?.repeatDisbursement).toFixed(2)).toLocaleString('en-IN') ?? 0,
                "Total Disbursement Amount": Number(parseFloat(callback?.totalDisbursement).toFixed(2)).toLocaleString('en-IN') ?? 0
            })
        })
    }
    const handleAccordData = (sDate, eDate) => {
        const start = moment(sDate).format("DD-MM-YYYY")
        const end = moment(eDate).format("DD-MM-YYYY")
        setLoader(true)
        projectionDataDaywise(noOfMonth, start, end, callback => {
            setLoader(false)
            setTableData(callback ?? [])
        })
    }
    return (
        <>
            {loader ? <Loader /> : ""}
            <div className='OverView-Main-Section min-size-marketing-1800'>
                
                <div className='HeadingFilter-Section'>
                    <div>
                        <h4 onClick={(e) => handleBack(e)}
                            style={{
                                margin: 0,
                                display: 'flex', gap: '5px', alignItems: 'center', whiteSpace: 'nowrap', cursor: 'pointer'
                            }}
                        > <ChevronLeft />Projection Management</h4>
                    </div>
                    
                    <div className='topsTabs' style={{ border: 'none' }}>
                        <div className='rightTabs' style={{ padding: '0' }}>
                            <button className={`rightSideBtn active`} style={{ background: '#035865', color: '#fff' }} >Export</button>
                        </div>
                    </div>
                </div>
                <div className='HeadingFilter-main-filters' style={{ marginTop: customMarginTop }}>
                        <div className="row">
                            <div className="col-xl-9 col-lg-10 col-xs-12" style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
                                {/* <div className='custom-popup' style={{ width: '30%' }}>
                                    <div className='customSelectBox ' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20px', cursor: 'pointer' }} onClick={() => handleDateFilterPopup("show", !dateFilterPopup?.show)}>
                                        <div style={{ display: 'flex', gap: '7px', alignItems: 'center' }}>
                                            <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6 0.75V2.25M3 0.75V2.25" stroke="#0C0B10" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M4.875 1.5H4.125C2.71079 1.5 2.00368 1.5 1.56434 1.93934C1.125 2.37868 1.125 3.08579 1.125 4.5V5.25C1.125 6.6642 1.125 7.37134 1.56434 7.81065C2.00368 8.25 2.71079 8.25 4.125 8.25H4.875C6.2892 8.25 6.99634 8.25 7.43565 7.81065C7.875 7.37134 7.875 6.6642 7.875 5.25V4.5C7.875 3.08579 7.875 2.37868 7.43565 1.93934C6.99634 1.5 6.2892 1.5 4.875 1.5Z" stroke="#0C0B10" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M1.125 3.75H7.875" stroke="#0C0B10" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            {
                                                dateFilterPopup?.from && dateFilterPopup?.to
                                                    ? `${moment(dateFilterPopup?.from).format("DD MMM YYYY")} - ${moment(dateFilterPopup?.to).format("DD MMM YYYY")}`
                                                    : "Select Date Range"
                                            }
                                        </div>
                                        <div style={{ marginTop: '-5px' }}>
                                            <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.375 0.375025C7.375 0.375025 4.79731 3.375 3.875 3.375C2.95263 3.375 0.375 0.375 0.375 0.375" stroke="#686C70" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                    {
                                        dateFilterPopup?.show ?
                                            <CustomDateFilter
                                                payload={dateFilterPopup}
                                                handlechange={handleDateFilterPopup}
                                                handleApply={handleApplyDteFilter}
                                            />
                                            : ""}
                                </div> */}
                                <DateFilterSelect
                                    value={[new Date(commonFilter.fromDate), new Date(commonFilter.toDate)]}
                                    onChange={(range) => {
                                        handleDateFilterPopup("from", range[0]);
                                        handleDateFilterPopup("to", range[1]);
                                    }}
                                    isFilterCleared={isFilterCleared}
                                />
                            </div>
                            <div className="col-xl-3 col-lg-2 col-xs-12" style={{ marginTop: '5px' }}>
                                <div style={{ display: 'flex', gap: '8px', justifyContent: window.innerWidth > 1200 ? 'end' : "start" }}>
                                    {/* <div className='custom-btn'>
                                    <i class="fa fa-filter" aria-hidden="true"></i>
                                </div> */}
                                    <div className='custom-btn'>
                                        <i class="fa fa-times" aria-hidden="true" onClick={() => handleReset()}></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                <div>
                    <StatsComponent
                        Data={statsOption}
                    />
                </div>

                <div className="container">
                    
                    <div style={{ marginTop: customMarginTop }}>
                        {
                            tableData?.length > 0 ? tableData?.map((val, id) => {
                                return (
                                    <CustomAccordion
                                        Data={val}
                                        ids={id}
                                        handleAccordion={handleAccordion}
                                        openAccordian={openAccordian}
                                    />
                                )
                            })
                                : ""}
                    </div>
                </div>
            </div>
        </>
    )
}


const CustomAccordion = ({ Data, ids, handleAccordion, openAccordian }) => {
    return (
        <>
            <div className="customAccords" style={{ marginTop: customMarginTop }}>
                <div className={`customTable ${ids == openAccordian ? "active" : ""}`}>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th className='iconExpand'>
                                    <InfoIcon onClick={() => handleAccordion(ids)} />
                                </th>
                                <th className='colorGreen'>{ids == openAccordian ? "Lead Particulars" : "Date"}</th>
                                {
                                    Data?.length > 0 && Data?.map((value, id) => {
                                        return (
                                            <th className='colorGreen'><b>{value?.date?.value}</b></th>
                                        )
                                    })
                                }
                            </tr>
                        </thead>

                        {
                            ids == openAccordian ?
                                <tbody>
                                    <tr>
                                        <td className='colorGreen' style={{ borderBottom: '1px solid #eee' }}></td>
                                        <td className='' style={{ borderBottom: '1px solid #eee' }}>Lead to Fresh Approval Ratio</td>
                                        {
                                            Data?.length > 0 && Data?.map((value, id) => {
                                                return (
                                                    <td className='' style={{ borderBottom: '1px solid #eee' }}>{value?.leadToFreshApprovalRatio?.value}</td>
                                                )
                                            })
                                        }
                                    </tr>
                                    <tr>
                                        <td className='colorGreen' style={{ borderBottom: '1px solid #eee' }}></td>
                                        <td className='' style={{ borderBottom: '1px solid #eee' }}>Lead to Fresh Disbursal Ratio</td>
                                        {
                                            Data?.length > 0 && Data?.map((value, id) => {
                                                return (
                                                    <td className='' style={{ borderBottom: '1px solid #eee' }}>{value?.leadToFreshDisbursalRatio?.value}</td>
                                                )
                                            })
                                        }
                                    </tr>
                                    <tr>
                                        <td className='colorGreen' style={{ borderBottom: '1px solid #eee' }}></td>
                                        <td className='' style={{ borderBottom: '1px solid #eee' }}>Lead to Fresh Rejection Ratio</td>
                                        {
                                            Data?.length > 0 && Data?.map((value, id) => {
                                                return (
                                                    <td className='' style={{ borderBottom: '1px solid #eee' }}>{value?.leadToFreshRejectionRatio?.value}</td>
                                                )
                                            })
                                        }
                                    </tr>
                                    <tr>
                                        <td className='colorGreen' style={{ borderBottom: '1px solid #eee' }}></td>
                                        <td className='' style={{ borderBottom: '1px solid #eee' }}>New Applications</td>
                                        {
                                            Data?.length > 0 && Data?.map((value, id) => {
                                                return (
                                                    <td className='' style={{ borderBottom: '1px solid #eee' }}>{value?.freshLeads?.value}</td>
                                                )
                                            })
                                        }
                                    </tr>
                                    <tr>
                                        <td className='colorGreen' style={{ borderBottom: '1px solid #eee' }}></td>
                                        <td className='' style={{ borderBottom: '1px solid #eee' }}>Repeat Applications</td>
                                        {
                                            Data?.length > 0 && Data?.map((value, id) => {
                                                return (
                                                    <td className='' style={{ borderBottom: '1px solid #eee' }}>{value?.repeatLeads?.value}</td>
                                                )
                                            })
                                        }
                                    </tr>
                                    <tr>
                                        <td className='colorGreen' style={{ borderBottom: '1px solid #eee' }}></td>
                                        <td className='' style={{ borderBottom: '1px solid #eee' }}>Approved Applications</td>
                                        {
                                            Data?.length > 0 && Data?.map((value, id) => {
                                                return (
                                                    <td className='' style={{ borderBottom: '1px solid #eee' }}>{value?.approvedLeads?.value}</td>
                                                )
                                            })
                                        }
                                    </tr>
                                    <tr className='customrow'>

                                        <td className=''></td>
                                        <td className='colorGreen'>CAC</td>
                                        <td className=''></td>
                                        <td className=''></td>
                                        <td className=''></td>
                                        <td className=''></td>

                                    </tr>
                                    <tr>
                                        <td className='colorGreen' style={{ borderBottom: '1px solid #eee' }}></td>
                                        <td className='' style={{ borderBottom: '1px solid #eee' }}>Lead to Repeat Approval Ratio</td>
                                        {
                                            Data?.length > 0 && Data?.map((value, id) => {
                                                return (
                                                    <td className='' style={{ borderBottom: '1px solid #eee' }}>{value?.leadToRepeatApprovalRatio?.value}</td>
                                                )
                                            })
                                        }
                                    </tr>
                                    <tr>
                                        <td className='colorGreen' style={{ borderBottom: '1px solid #eee' }}></td>
                                        <td className='' style={{ borderBottom: '1px solid #eee' }}>Lead to Repeat Disbursal Ratio</td>
                                        {
                                            Data?.length > 0 && Data?.map((value, id) => {
                                                return (
                                                    <td className='' style={{ borderBottom: '1px solid #eee' }}>{value?.leadToRepeatDisbursalRatio?.value}</td>
                                                )
                                            })
                                        }
                                    </tr>
                                    <tr>
                                        <td className='colorGreen' style={{ borderBottom: '1px solid #eee' }}></td>
                                        <td className='' style={{ borderBottom: '1px solid #eee' }}>Total Disbursed Leads</td>
                                        {
                                            Data?.length > 0 && Data?.map((value, id) => {
                                                return (
                                                    <td className='' style={{ borderBottom: '1px solid #eee' }}>{value?.disburseLeads?.value}</td>
                                                )
                                            })
                                        }
                                    </tr>
                                    <tr>
                                        <td className='colorGreen' style={{ borderBottom: '1px solid #eee' }}></td>
                                        <td className='' style={{ borderBottom: '1px solid #eee' }}>Total Disbursed Amount</td>
                                        {
                                            Data?.length > 0 && Data?.map((value, id) => {
                                                return (
                                                    <td className='' style={{ borderBottom: '1px solid #eee' }}>{value?.disburseAmount?.value}</td>
                                                )
                                            })
                                        }
                                    </tr>
                                </tbody>
                                :
                                <tbody>
                                    <tr>
                                        <td className='colorGreen' style={{ borderBottom: '1px solid #eee' }}></td>
                                        <td className='colorGreen' style={{ borderBottom: '1px solid #eee' }}>Application</td>
                                        {
                                            Data?.length > 0 && Data?.map((value, id) => {
                                                return (
                                                    <td className='' style={{ borderBottom: '1px solid #eee' }}>{value?.totalLeads?.value}</td>
                                                )
                                            })
                                        }
                                    </tr>
                                    <tr>
                                        <td className='colorGreen' style={{ borderBottom: '1px solid #eee' }}></td>
                                        <td className='colorGreen' style={{ borderBottom: '1px solid #eee' }}>Disbursed Amount</td>
                                        {
                                            Data?.length > 0 && Data?.map((value, id) => {
                                                return (
                                                    <td className='' style={{ borderBottom: '1px solid #eee' }}>{value?.disburseAmount?.value}</td>
                                                )
                                            })
                                        }
                                    </tr>
                                </tbody>
                        }
                    </table>
                </div>
            </div>
        </>
    )
}